<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>
        <v-spacer></v-spacer>

        <action-button
          type="cancel"
          @click="$emit('return_modal_cancel_form', { module: 'enrolment-organisation-user' })"
          v-if="modal == true"
        />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md3 sm6 xs12>
                <v-text-field
                  name="employee_number"
                  v-model="organisation.name"
                  :label="$t('enrolments.o_name')"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md3 sm6 xs12>
                <v-text-field
                  :value="participant ? participant.first_name + ' ' + participant.last_name : ''"
                  :label="$t('attendees.participant_id')"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md3 sm6 xs12>
                <v-text-field
                  name="employee_number"
                  v-model="data.employee_number"
                  :label="$t('participants.employee_number')"
                  :error-messages="errors.collect('employee_number')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md3 sm6 xs12>
                <v-autocomplete
                  name="department"
                  v-model="data.department_id"
                  :items="departments"
                  item-text="name"
                  item-value="id"
                  :label="$t('enrolments.department')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('department')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md3 sm6 xs12 class="py-5">
                <v-simple-checkbox
                  class="float-left mr-2"
                  name="user_id"
                  :value="Boolean(data.user_id)"
                  hide-details
                  dense
                  @input="companyUserChange(!data.user_id ? 'create' : 'delete', $event)"
                >
                </v-simple-checkbox>
                <p class="float-left">{{ $t("logs.user_id") }}</p>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "EnrolmentOrganisationUserForm",

  props: ["enrolment_organisation_id", "participant_id", "participant", "modal"],

  data() {
    return {
      page_title: this.$t("global.edit"),
      predata: {},
      data: {},
      organisation: {},
      departments: [],
      dictionary: {
        attributes: {
          employee_number: this.$t("participants.employee_number"),
          department_id: this.$t("enrolments.department"),
          user_id: this.$t("logs.user_id")
        }
      }
    }
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    this.init()
  },

  methods: {
    init() {
      axios
        .get(this.API_URL + "enrolment/organisation/" + this.enrolment_organisation_id)
        .then((res) => {
          this.organisation = res.data.data

          axios
            .get(
              this.API_URL +
                "enrolmentorganisationdepartments" +
                "?show_all=true&query_enrolment_organisation_id=" +
                this.enrolment_organisation_id
            )
            .then((res) => {
              this.departments = res.data.data
            })

          axios
            .get(this.API_URL + "enrolmentorganisationuser/" + this.enrolment_organisation_id + "/" + this.participant_id)
            .then((res) => {
              this.data = res.data
              this.predata = JSON.parse(JSON.stringify(this.data))
            })
            .catch((err) => console.log(err))
        })
        .catch((err) => console.log(err))
    },
    save() {
      let vm = this
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            axios
              .put(this.API_URL + "enrolmentorganisationuser", {
                enrolment_organisation_id: this.data.enrolment_organisation_id,
                participant_id: this.data.participant_id,
                employee_number: this.data.employee_number,
                department_id: this.data.department_id
              })
              .then((res) => {
                vm.data = res.data
                vm.predata = JSON.parse(JSON.stringify(vm.data))

                if (vm.modal) {
                  vm.$emit("return_modal_form", {
                    module: "enrolment-organisation-user",
                    mode: "edit",
                    data: res.data
                  })
                }
              })
              .catch((err) => console.log(err))
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    companyUserChange(mode, value) {
      let vm = this
      let url = this.API_URL + (value ? "participant/add-company-access" : "participant/remove-company-access")
      let obj = {
        first_name: this.participant.first_name,
        last_name: this.participant.last_name,
        company_name: this.organisation.name
      }

      this.$awn.confirm(
        mode == "create" ? this.$t("enrolments.employee_user_access", obj) : this.$t("enrolments.employee_user_remove", obj),
        () => {
          axios
            .post(url, {
              participant_id: this.participant_id,
              company_id: this.enrolment_organisation_id
            })
            .then((res) => {
              if (typeof res.data.errors !== "undefined") {
              } else {
                if (mode == "create") {
                  vm.$awn.success(vm.$t("global.create_success"))
                }

                if (mode == "delete") {
                  vm.$awn.success(vm.$t("global.delete_success"))
                }

                vm.data.user_id = value
              }
            })
            .catch((err) => console.log(err))
        },
        () => {},
        {
          labels: {
            confirm: ""
          }
        }
      )
    }
  }
}
</script>

<style>
.form-modal {
  background: white;
}
</style>
